// extracted by mini-css-extract-plugin
export var growableInput = "_62-0";
export var tagContainer = "_62-2";
export var textInput = "_62-1";